export const baseURL =
  "https://consulting-projects.academy-faculty.repl.co/api";
export const projectsURL = `${baseURL}/projects`;
export const clientsURL = `${baseURL}/clients`;
export const employeesURL = `${baseURL}/employees`;
